import { createNamedContext } from '@utils';

type WhitelabelMenuDisplayContextValue = {
  whitelabel: boolean;
};

export const WhitelabelMenuDisplayContext = createNamedContext<WhitelabelMenuDisplayContextValue>(undefined, 'Whitelabel.MenuDisplay.Context');